import { OPEN_MODAL_PASSWORD } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (value) => companyUsersActions[OPEN_MODAL_PASSWORD](value);
